const { useIntl } = require("react-intl");

const useTranslate = () => {
  const { formatMessage } = useIntl();
  /**
   *
   * @param id
   * @param values
   * @returns {string}
   */
  const t = (id, values) => formatMessage({ id }, values);

  return t;
};

export default useTranslate;